module.exports = __webpack_public_path__ + "static/img/404.0ba3461.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404.png
// module id = CgFv
// module chunks = 1